import type { RouteObject } from 'react-router-dom'

const candidatesRoute: RouteObject = {
  path: 'process',
  children: [
    { path: 'psikotest', lazy: () => import('@/pages/process/psikotest/page') },
    { path: 'test-case-by-department', lazy: () => import('@/pages/process/test-case-by-department/page') },
    { path: 'mcu', lazy: () => import('@/pages/process/mcu/page') },
    { path: 'first-interview', lazy: () => import('@/pages/process/first-interview/page') },
    { path: 'second-interview', lazy: () => import('@/pages/process/second-interview/page') },
    { path: 'document-request', lazy: () => import('@/pages/process/document-request/page') },
    { path: 'assessment', lazy: () => import('@/pages/process/assessment/page') },
    {
      path: 'document-request',
      children: [
        { path: '', lazy: () => import('@/pages/process/document-request/index/page') },
        { path: ':applicantId/create', lazy: () => import('@/pages/process/document-request/create/page') },
        { path: ':applicantId/revise', lazy: () => import('@/pages/process/document-request/revise/page') },
        { path: ':applicantId/upload-documents', lazy: () => import('@/pages/process/document-request/upload-documents/page') },
        { path: ':applicantId/upload-signed', lazy: () => import('@/pages/process/document-request/upload-signed/page') },
        { path: ':applicantId/view-signed', lazy: () => import('@/pages/process/document-request/view-signed/page') },
        { path: ':candidateId/preview', lazy: () => import('@/pages/process/document-request/preview/page') },
      ],
    },
    { path: 'onboarding', lazy: () => import('@/pages/process/onboarding/page') },
  ],
}

export default candidatesRoute
